import { BaseError } from "./BaseError";
import type { ErrorContext } from "../types/index";
import { EXTERNAL_SERVICE_ERROR_CODES } from "../constants/errorCodes";

export interface ExternalServiceErrorOptions {
  message: string;
  serviceName?: string;
  serviceUrl?: string;
  statusCode?: number;
  context?: Partial<ErrorContext>;
  code?: string;
  cause?: Error;
}

/**
 * Error thrown for external service-related issues
 */
export class ExternalServiceError extends BaseError {
  public readonly serviceName?: string;
  public readonly serviceUrl?: string;
  public readonly serviceStatusCode?: number;

  constructor(options: ExternalServiceErrorOptions) {
    super({
      message: options.message,
      category: "external_service",
      severity: "high",
      statusCode: options.statusCode ?? 502,
      code: options.code ?? EXTERNAL_SERVICE_ERROR_CODES.EXTERNAL_SERVICE_ERROR,
      context: options.context,
      cause: options.cause,
      userVisible: false,
      reportable: true,
    });

    this.serviceName = options.serviceName;
    this.serviceUrl = options.serviceUrl;
    this.serviceStatusCode = options.statusCode;
  }
}
